module.exports = __webpack_public_path__ + "img/17_31.7653d8ed.png";